<template>
  <div class="container">
    <img class="wheelPrize-bg" src="https://pstatic.navi-sci.cn/20251010134246_80_6.jpg" @click="openQRcodeBox">
    <img class="wheelPrize-toPre" src="https://pstatic.navi-sci.cn/wheelPrize_act/PC_wheelPrize_toPre" @click="toPre">

    <!-- 二维码弹窗 -->
    <div v-if="openQRcode" class="QRcode-box">
     <div class="QRcode-box-content">
         <img src="https://pstatic.navi-sci.cn/wheelPrize_act/PC_wheelPrize_QrCode" alt="">
         <i class="el-icon-close" @click="openQRcode = false"></i>
         <div class="QRcode-main">
             <img :src="QRCode_main">
         </div>
     </div>
    </div>
  </div>
</template>

<script>
import { getWheelDetail, getQRcode } from '@/api/request'

export default {
    data() {
        return {
            openQRcode: false,
            QRCode_main: '',
            info_list: [],
        }
    },
    created() {
        const id = this.$route.query.activityId
        getWheelDetail(id).then(res => {
            const list_items = res.data.list.slice(0, 2)
			this.info_list = res.data.list.concat(list_items)
        })
        getQRcode('pages/index/index', '400', '-').then(res=>{
            this.QRCode_main = 'data:image/png;base64,' + res.qrCodeBytes
        })
    },
    methods: {
        // 生成跳转小程序的二维码
        openQRcodeBox() {
            this.openQRcode = true
        },
        // 跳转前往预存
        toPre() {
            let obj = this.$store.getters;
            if(obj.token){
                this.$router.push({
                    path: "/aboutUsIndex",
                    query: { type: 13, tabIndex: '1-1', tabName: '我的资产' },
                });
            }else{
                this.$message.warning("请先登录")
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.container {
    position: relative;
    display: flex;
    justify-content: center;
    .wheelPrize-button {
        position: absolute;
        top: 465px;
        width: 90px;
    }
    .wheelPrize-toPre {
        position: absolute;
        top: 1300px;
    }
}

.QRcode-box {
    position: fixed;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);

    .QRcode-box-content {
        animation: openQRcode linear 0.2s;
        position: relative;
        width: 500px;
        height: 700px;

        img {
            width: 500px;
            height: 700px;
        }

        .el-icon-close {
            position: absolute;
            top: 30px;
            right: 30px;
            color: #ffffff;
            transform: scale(4);
        }

        .QRcode-main {
            position: absolute;
            bottom: 150px;
            left: 50%;
            transform: translateX(-50%);
            width: 300px;
            height: 300px;
            border-radius: 50%;
            background-color: #ffffff;
            img {
                width: 300px;
                height: 300px;
                border-radius: 50%;
            }
        }
    }
}
</style>